<template>
  <page-layout class="article_tag">

    <div class="inner">
      <div class="tag">
        <p>Tag :</p>
        <p class="ctry_kr">#{{$route.params.tag}}</p>
      </div>
    </div>

    <sub-page-layout>

      <div class="title">
        <h3>{{getTagPosts.total}} Articles</h3>
        <drop-down :data="sortOptions" key-name="key" value-name="value" :default-key="sortKey" :action="clickDrowdownRow"></drop-down>
      </div>

      <ul class="lst" id="lst">
        <li v-for="(post, index) in queryData" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index) }">

          <div v-if="showSubMiddleBanner(index)" class="banner">
            <display-container :section="313" empty-bg-color="transparent">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
              </template>
            </display-container>
            <!--<ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-5310971739125617"
             data-ad-slot="1019921057"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>-->
          </div>

          <post-container :post="post"></post-container>
        </li>
      </ul>

      <a class="lst_no" v-if="!getTagPosts.loading && getTagPosts.total < 1">Did not match any articles</a>
      <a class="lst_more" :disabled="getTagPosts.loading" v-if="!isTagPostsFinish && getTagPosts.total > 0" @click="getMoreTagPosts()">Load More Articles</a>

    </sub-page-layout>
  </page-layout>
</template>

<script>
  import {Loading, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import SubPageLayout from '../layouts/SubPageLayout'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import {mapGetters} from 'vuex'
  export default {
    name: 'ArticleTag',
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    metaInfo () {
      return {
        title: `${this.getAppName} tag | #${this.$route.params.tag}`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `#${this.$route.params.tag}, ${this.getTagPosts.total}개 아티클`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `#${this.$route.params.tag} | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `#${this.$route.params.tag}, ${this.getTagPosts.total}개 아티클`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        sortKey: 'pub_dt',
        sortOptions: [
          {key: 'pub_dt', value: '최신순'},
          {key: 'view_cnt', value: '인기순'}
        ]
      }
    },
    created() {
      this.getRouteQuery()
    },
    activated () {
      this.$store.dispatch('callTagPosts')
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getTagPosts',
        'isTagPostsFinish',
        'isExistDisplaySubMiddleBanner'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      queryData () {
        return this.getTagPosts.data
          .sort((a, b) => a['idx'] > b['idx'] ? 1 : -1)
          .sort((a, b) => a[this.sortKey] < b[this.sortKey] ? 1 : -1)
      }
    },
    methods: {
      ...CommonMethods,
      getRouteQuery() {
        const query = this.$route.query
        const rtn = this.sortOptions.find(row => row.key === query.sort)
        if (rtn) this.sortKey = query.sort
      },
      getMoreTagPosts () {
        this.$store.dispatch('loadTagPosts')
      },
      clickDrowdownRow (row) {
        this.sortKey = row.key
        this.$router.replace({query: {sort: row.key}})
      },
      showSubMiddleBanner (index) {
        return index > 0 && index%6===0 && this.isMobile && this.isExistDisplaySubMiddleBanner
      }
    }
  }
</script>

<style scoped>
  .tag {
    display: block;
    text-align: center;
    /*border-bottom: 1px solid #000;*/
    padding-bottom: 35px;
  }
  .tag p {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .tag p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 60px;
    font-weight: 900;
  }
</style>
